<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>

    <div class="form-edit-page">
        <form @submit.prevent="submitForm">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Bairro</label>
                    <div class="field-label field-label-end">{{ objEdicao.cdbairro }}</div>
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Nome</label>
                    <input type="text" v-model="objEdicao.nmbairro" v-uppercase required maxlength="100" />
                </div>

                <div class="form-item-coordenadas">
                    <CoordenadasSelect v-model:modelValueLatitude="edLatitude" v-model:modelValueLongitude="edLongitude" />
                </div>
            </div>


            <div class="row-end row-space">
                <label>Ativo</label>
                <input type="checkbox" class="input-checkbox" v-model="ckAtivo" />
            </div>


            <div class="row-end">
                <button class="btn-confirm" type="submit">Salvar</button>
                <button class="btn-cancel" type="cancel" @click="cancelForm">Cancelar</button>
            </div>
        </form>
    </div>
</template>
  
<script setup>
import { ref, onMounted } from 'vue';
import { criarBairro } from '@/models/Bairro';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import CoordenadasSelect from '@/components/CoordenadasSelect.vue';

const emit = defineEmits(['close', 'salvo']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const ckAtivo = ref(false);
const edLatitude = ref(null);
const edLongitude = ref(null);
const objEdicao = ref(criarBairro());
const isLoading = ref(false);

const submitForm = async () => {
    try {
        isLoading.value = true;
        objEdicao.value.latitude    = !edLatitude.value ? 0 : parseFloat(edLatitude.value.toString().replace(',', '.')) || 0;
        objEdicao.value.longitude   = !edLongitude.value ? 0 : parseFloat(edLongitude.value.toString().replace(',', '.')) || 0;
        objEdicao.value.ativo       = ckAtivo.value ? 'S' : 'N';
        const response  = await genericPut('/cad/bairro', objEdicao.value);
        if (response.bolok === 1){
            emit('salvo');
            emit('close');
        }else{
            alert(response.erro);
        }
    } catch (error) {console.error('Error:', error);
    } finally{isLoading.value=false;}
};

const cancelForm = () => {emit('close');};

const lerDados = async() => {
    try{
        isLoading.value=true;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('bairro', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
                edLatitude.value    = objEdicao.value.latitude;
                edLongitude.value   = objEdicao.value.longitude;
            }catch (error){console.error('Erro leitura dos dados', error);}
        }else{
            objEdicao.value.idmunicipio = globalStore.idmunicipio;
        }
        objEdicao.value.idusuario   = globalStore.idusuario;
        ckAtivo.value               = objEdicao.value.ativo==='S';
    }finally{isLoading.value=false;}
};

onMounted(lerDados);
</script>